<!--
    „Beratungsdokumentation" of the consultant shell — one table over all cw.CwConsultationDoc rows.
    A row click hands the object to the shell's right drawer (see handleObjectSelect); the widget is
    the whole surface, so there is no inline page header here.
-->
@if (initialized) {
    @if (widgetConsultationDocs) {
        <mvs-widget [widgetData]="widgetConsultationDocs"
                    (onObjectSelect)="handleObjectSelect($event)">
        </mvs-widget>
    }
}
